<template>
  <div>


    <vs-breadcrumb class="mb-6" :items="
   [
     {
       title: '分类',
       url: '/category/list'
     },
     {
       title: '创建新分类',
       active: true
     }
   ]"></vs-breadcrumb>



    <vx-card title="创建新分类" class="mb-6">
      <vs-divider position="left" class="text-bold">基本信息</vs-divider>
      <template>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full flex flex-row-reverse">
            <span>分类名称</span>
          </div>
          <div class="vx-col sm:w-5/6 w-full">
            <vs-input class="w-full" v-model="name" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full flex flex-row-reverse">
            <span>排序</span>
          </div>
          <div class="vx-col sm:w-5/6 w-full">
            <vs-input class="w-full" v-model="sort" type="number" />
          </div>
        </div>
      </template>
      <vs-divider position="left" class="text-bold">确认以上信息无误, 提交创建表单</vs-divider>
      <div class="vx-row">
        <div class="vx-col w-full flex justify-center">
          <vs-button class="mr-3 mb-2" @click="submitData">提交创建</vs-button>
          <vs-button color="primary" type="border" class="mb-2" @click="name = sort = ''">重置</vs-button>
        </div>
      </div>
    </vx-card>

    <vs-popup title="操作提示" :active.sync="createPopUpActive">
      <div>是否确定创建新分类?</div>
      <div class="flex mt-3">
        <vs-button class="mr-3" @click="confirmCreate" :disabled="btnDisabled">确定创建</vs-button>
        <vs-button type="border" @click="cancelCreate" :disabled="btnDisabled">取消</vs-button>
      </div>
    </vs-popup>
  </div>
</template>
<script>
  import categoryRepo from '@/repo/category'
  export default {
    data() {
      return {
        createPopUpActive: false,
        name: '',
        sort: 1,
        btnDisabled: false
      }
    },
    methods: {
      submitData: function () {
        const name = this.name
        const sort = this.sort
        if (name === '') {
          this.openNotify('分类名称不能为空')
        } else if (sort === '') {
          this.openNotify('分类排序不能为空')
        } else {
          this.createPopUpActive = true
        }
      },

      openNotify: function (msg, color = 'danger') {
        this.$vs.notify({
          position: 'bottom-center',
          color: color,
          title: '操作提示',
          text: msg
        })
      },


      confirmCreate: function () {
        this.btnDisabled = true
        const postData = {
          name: this.name,
          sort: this.sort
        }
        categoryRepo.create(postData, (error, data) => {
          this.btnDisabled = false

          if (error) {
            this.openNotify('创建新分类失败')
          }
          console.log(data)
          if (data.code === 0) {
            this.openNotify(data.msg, 'success')
            this.createPopUpActive = false
          } else {
            this.openNotify(data.msg)
          }
        })
      },

      cancelCreate: function () {
        this.createPopUpActive = false
      }
    }
  }
</script>
<style scoped>
</style>
